<template lang="pug">
    div
        .lock-screen(v-if="lockScreen")
        v-card(pa-3)
            v-divider(v-if="posSaleType === 2")
            pay(v-if="!(totalToPay <= 0)" @clean-form="cleanForm")
            v-divider
            v-card-text
                payment-details
            v-card-text
                v-card(color="grey" pa-1)
                    v-card-text
                        v-layout(row wrap)
                            .headline Pago autorizado:
                                v-text-field.headline(solo readonly
                                :mask="mixCurrencyMask(totalPaid, 12)"
                                prefix="$"
                                v-model="totalPaid")
                            v-spacer
                            .headline Vuelto:
                                v-text-field.headline(solo readonly
                                    :mask="mixCurrencyMask(change, 12)"
                                    prefix="$"
                                    v-model="change")
            //- .title(v-if="posSaleType === 2") N° de orden de Compra 
            //- v-text-field.title(
            //-     ref="ocNum"
            //-     solo
            //-     v-if="posSaleType === 2"
            //-     placeholder="Ingrese N° de Orden de Compra en caso de existir una"
            //-     v-model="OC"
            //-     mask="#######"
            //-     :disabled="!(totalToPay <= 0)"
            //-     @input="setOC()")
            v-expansion-panel(v-if="posSaleType === 2")
                v-expansion-panel-content()
                    div(slot='header') N° de orden de Compra
                    v-card
                        v-card-text
                            v-text-field.title(
                                ref="ocNum"
                                solo
                                v-if="posSaleType === 2"
                                placeholder="Ingrese N° de Orden de Compra en caso de existir una"
                                v-model="OC"
                                :disabled="!(totalToPay <= 0)"
                                @input="setOC()"
                                maxLength=18
                                )
                                
                v-expansion-panel-content()
                    div(slot='header') Observación Factura
                    v-card
                        v-card-text
                            v-text-field.title(
                                ref="invObservation"
                                
                                v-if="posSaleType === 2"
                                placeholder="Ingrese Observación de factura en caso de existir una"
                                v-model="invoiceObservation"
                                :disabled="!(totalToPay <= 0)"
                                @input="setInvObservation()")
                                multi-line
            v-card-actions
                v-btn.white--text(color="red darken-3" round small
                    @click="cleanTicket") Limpiar Ticket
                v-spacer
                v-btn(outline round color="indigo" @click="annulSale")
                                        |Anular Ticket
                v-spacer
                v-btn.white--text#btn-confirm-sale(color="blue darken-3" round
                    @click='confirmSale' @keyup.enter='confirmSale'
                    :disabled="!(saleFinalToPay <= 0) || lockScreen") Confirmar venta (F8)  
                AuthModal(
                    available
                    style="position: absolute; left: -2000px; top: 0px;"
                    @check-key="checkAuth()"
                    ref="authModal"
                    )
                    ul.subheading
                        li(v-if="requireExtraCreditAuth") 
                            | Esta venta excede el cupo permitido 
                            | para este cliente y requiere autorización
                        li(v-if="requireExtraCreditOptionAuth && requireExtraCreditOptionAuth.text")
                            | {{requireExtraCreditOptionAuth.text}}

</template>

<script>
// Components:
import Pay from './Pay'
import PaymentDetails from './PaymentDetails'
import { mapState, mapActions, mapGetters } from 'vuex'
import { ANNUL_SALE_ACTION } from '@/components/SnackbarModal/SnackbarActions'
import AuthModal from '@/components/SupervisorUniqueKey/Modal'

// Mixins:
import CurrencyUtils from '@/mixins/CurrencyUtils'

//Services:
import { timeout } from '@/services/AsyncUtils'
import { CLEAN_TICKET } from '@/components/SnackbarModal/SnackbarActions'
import { sendIntegrationTicketNumber } from '../../../services/API/Integration'

import { debounce, cloneDeep } from 'lodash'

import SlSaleCreditNote from '../../../models/Sale/SlSaleCreditNote'
import SlSaleCreditNoteService from '@/services/API/SaleModule/SlSaleCreditNote'

// 
const COMMIT_SALE_WAIT = process.env.VUE_APP_COMMIT_SALE_WAIT || 5000

export default {
    name: 'payment',
    props: {},
    data: function () {
        return {
            OC: '',
            invoiceObservation: '',
            lockScreen: false,
        }
    },
    computed: {
        ...mapState('CashDeskModule', {
            total: (state) => state.total,
            payment: (state) => state.payment,
            posSaleType: (state) => state.posSaleType,
            paymentDetail: (state) => state.paymentDetail,
            payer: (state) => state.payer,
            ticketCode: (state) => state.ticketCode,
            arrayPayments: (state) => state.arrayPayments,
            multipleSaleTicket: (state) => state.multipleSaleTicket,
        }),
        ...mapState('SessionModule', ['isTransbankIntegrated', 'companyData']),
        ...mapState('AuthModule', { TBK: 'tbk' }),

        // FIXME: Remove in production
        ...mapState('IntegrationModule', {
            ticketCounter: 'ticketCounter',
            officeID: 'officeID',
        }),
        // ENDFIXME

        ...mapState('CustomerModule', {
            customerData: (state) => state.customerData,
            coreBusinessSelected: (state) => state.coreBusinessSelected,
        }),

        ...mapGetters('CashDeskModule', {
            change: 'change',
            roundingLaw: 'roundingLaw',
            allDataSet: 'allDataSet',
            totalToPay: 'totalToPay',
            totalPaid: 'totalPaid',
            saleFinalToPay: 'saleFinalToPay',
            requireExtraCreditAuth: 'requireExtraCreditAuth',
            requireExtraCreditOptionAuth: 'requireExtraCreditOptionAuth',
        }),

        ...mapGetters('AuthModule', [
            'branchOfficeID',
            'cashDeskID',
            'branchOfficeName',
            'branchOfficeAddress',
        ]),

        ...mapState('SnackbarModalModule', {
            showSnackbar: 'showSnackbar',
            responseConfirm: 'responseConfirm',
        }),

        /**
         * 
         */
        officeData() {
            return {
                officeID: this.branchOfficeID,
                officeName: this.branchOfficeName + ' - ' + this.branchOfficeAddress,
                officeCashDeskId: this.cashDeskID,
            }
        },
    },
    methods: {
        ...mapActions('SnackbarModalModule', {
            initSnackbar: 'initSnackbar',
            hideSnack: 'hideSnack',
            resetSnackbarState: 'resetSnackbarState',
            setMessageConfirmSnack: 'setMessageConfirmSnack',
        }),
        ...mapActions('CashDeskModule', {
            resetCashDeskState: 'resetCashDeskState',
            submitSale: 'submitSale',
            clearPayment: 'clearPayment',
            printDTE: 'printDTE',
            reprintDTE: 'reprintDTE',
            resetSale: 'resetSale',
            setPurchaseOrder: 'setPurchaseOrder',
            printVoucher: 'printVoucher',
            setInvoiceObservation: 'setInvoiceObservation',
            setArrayPayments: 'setArrayPayments',
        }),
        ...mapActions('CustomerModule', {
            resetCostumerState: 'resetCostumerState',
        }),
        ...mapActions('UniqueKeyModule', {
            authorize: 'authorize',
            setPermission: 'setPermission',
        }),

        setOC() {
            this.setPurchaseOrder(this.OC)
        },

        setInvObservation() {
            this.setInvoiceObservation(this.invoiceObservation)
        },
        confirmSale() {
            if (
                !this.requireExtraCreditAuth &&
                !this.requireExtraCreditOptionAuth
            )
                this.commitSale()
            else {
                this.setPermission(
                    this.mixAuthCodePermissions
                        .CREATE_AUTH_POS_DAILY_SALE_REPORT
                )
                this.$refs.authModal.$el
                    .querySelector('#supervisor-modal-button')
                    .click()
            }
        },

        // async commitSale() {
        commitSale: debounce(async function () {

            // lock windows screen
            this.lock()

            //
            this.initSnackbar({
                typeMessage: 'info',
                message: {
                    title: 'Preparando Venta',
                    body: 'Confirmando datos venta',
                },
                timeout: 0,
                showProgress: true,
                showCloseBtn: true,
                closeBtnMessage: '',
            }) // Showing info + loading snackbar
            // Here: Insert TBK Logic
            if (!this.arrayPayments || !this.arrayPayments.length) return

            if (
                this.arrayPayments.filter((p) =>
                    [2, 3].includes(p.paymentMethod)
                ).length > 1
            ) {
                this.resetSnackbarState()
                this.initSnackbar({
                    typeMessage: 'error',
                    message: {
                        title: 'Error en Pagos',
                        body:
                            'Sólo puede registrarse un pago con' +
                            'débito o uno con crédito',
                    },
                    timeout: 0,
                    showProgress: false,
                    showCloseBtn: true,
                    closeBtnMessage: 'cerrar',
                })
                return
            }
            let tbk = this.arrayPayments.find((p) =>
                [2, 3].includes(p.paymentMethod)
            )
            let tbkData = null

            // check only numbers
            function onlyNumbers(str) {
                return /\d/.test(str)
            }

            // check if transbank detail has carrier identifier
            let isCarrier = !!tbk && onlyNumbers(tbk.paymentDetail.voucher)
            // let isTransbank = false
            let isTransbank = this.isTransbankIntegrated

            // debug
            // console.log({ tbk })
            // console.log({ isCarrier })
            // console.log({ isTransbank })

            // check if required transbank machine
            if (tbk && isTransbank && !isCarrier) {
                try {
                    this.initSnackbar({
                        typeMessage: 'info',
                        message: {
                            title: 'Conectando a Transbank',
                            body: 'Por favor opere POS de transbank',
                        },
                        timeout: 0,
                        showProgress: true,
                        showCloseBtn: true,
                        closeBtnMessage: '',
                    }) // Showing info + loading snackbar
                    tbkData = await this.TBK.sale(
                        this.multipleSaleTicket[0].id,
                        tbk.payment,
                        this.payer.toUpperCase() === 'SC' ? 1 : 2
                    )
                } catch (error) {
                    this.lockScreen = false
                    this.resetSnackbarState()
                    this.initSnackbar({
                        typeMessage: 'error',
                        message: {
                            title: 'Error de Transbank',
                            body: error,
                        },
                        timeout: 0,
                        showProgress: false,
                        showCloseBtn: true,
                        closeBtnMessage: 'cerrar',
                    })
                    return
                }
            }
            // if (tbk && !tbkData) return
            if (tbkData) {
                console.log('TRANSBANK_DATA', tbkData)
                let arrayPayments = cloneDeep(this.arrayPayments)
                let idx = arrayPayments.findIndex((p) =>
                    [2, 3].includes(p.paymentMethod)
                )
                arrayPayments[idx] = {
                    payment: tbk.payment,
                    paymentDetail: {
                        voucher: tbkData.operation_number,
                        shares_number: tbkData.shares_number,
                        terminal_id: tbkData.terminal_id,
                        authorization_code: tbkData.authorization_code,
                    },
                    paymentMethod: tbk.paymentMethod,
                }
                this.setArrayPayments(arrayPayments)
            }

            // show waiting save sale in database 
            this.showWaitingSaveSale()
            
            // this.initSnackbar({
            //     typeMessage: 'info',
            //     message: {
            //         title: 'Guardando Venta',
            //         body: 'Guardando venta en la base de datos',
            //     },
            //     timeout: 0,
            //     showProgress: true,
            //     showCloseBtn: true,
            //     closeBtnMessage: '',
            // }) 
            // Showing info + loading snackbar
            // If success, continue, else, snackbar

            //Enable for Printing Test
            // this.printDTE({
            //     billNum: 100,
            //     eSignatureURL: null,
            //     dateTime: null,
            //     isEmployee: false,
            //     isInternalConsumption: false,
            //     currentEnv: 'integration',
            // })
            // this.lockScreen = false
            // this.resetSnackbarState()
            // return

            // send sale payment
            // let response = {
            //     dte: {
            //         dte: {
            //             number: '15019',
            //             signature_url: 'http://agroapi.dev.dgz2.cl/storage/DTE/2020/2/26/signature-55286.png',
            //         }
            //     },
            //     dte_credit_note: {
            //         number: '15019',
            //         total: 1000,
            //     },
            //     status: 'success'
            // }
            // let response = await this.sale()
            let response = await this.submitSale({
                customerId: this.customerData.id,
                coreBusiness: this.coreBusinessSelected,
            })

            // check success sale payment
            if (response.status == 'success') {

                // if (this.posSaleType !== 2) {
                //     let response = sendIntegrationTicketNumber(
                //         this.officeID,
                //         this.ticketCounter
                //     )
                // }

                // unlock windows screen
                this.unlock()

                // show success save sale in database 
                this.showSuccessSaveSale()
                // this.initSnackbar({
                //     typeMessage: 'success',
                //     message: {
                //         title: 'Exito',
                //         body: 'Venta registrada exitosamente.',
                //     },
                //     timeout: 0,
                //     showProgress: false,
                //     showCloseBtn: true,
                //     closeBtnMessage: 'cerrar',
                // })

                // reset snackbar after 6 seconds
                setTimeout(this.resetSnackbarState, 6000)

                // print response
                let printRes = null

                // check payer type is employee ticket (SE)
                if (this.payer === 'SE') {
                    printRes = await this.printDTE({
                        billNum: this.ticketCode || '-',
                        eSignatureURL: null,
                        dateTime: null,
                        isEmployee: true,
                        isInternalConsumption: false,
                        currentEnv: 'integration',
                    })
                } else if (response.dte) {

                    // check dte provider
                    const dteResponse   = response.dte
                    const dteCreditNote = response.dte_credit_note
                    // const hasFile     = !!response.dte.url_file_dte
                    // const dteProvider = hasFile ? 'open_factura' : 'integration'
                    const dteProvider =
                        response.dte.url_file_dte === undefined
                            ? 'open_factura'
                            : 'integration'
                    const isSaleTicket  = this.posSaleType === 1
                    const isSaleInvoice = this.posSaleType === 2
                    const isIntegration = dteProvider === 'integration'
                    const isOpenFactura = dteProvider === 'open_factura'

                    // debug response
                    console.log({
                        isSaleTicket,
                        isSaleInvoice,
                        isIntegration,
                        isOpenFactura,
                    })

                    // check is invoice & integration
                    // if (isSaleInvoice && isIntegration) {
                    //     await this.printVoucher(dteFileUrl)
                    // }
                    if (
                        this.posSaleType === 2 &&
                        dteProvider === 'integration'
                    ) {
                        //
                        if (response.url_file_dte !== undefined) {
                            //nc
                            await this.printVoucher(response.url_file_dte)
                        }
                        await this.printVoucher(response.dte.url_file_dte) //factura
                    }

                    // check is invoice & open_factura
                    // if (isSaleInvoice && isOpenFactura) {
                    //     if (dteCreditNote) {
                    //         await this.downloadCreditNote(dteCreditNote)
                    //     }
                    //     await this.printDte()
                    // }
                    if (
                        this.posSaleType === 2 &&
                        dteProvider === 'open_factura'
                    ) {
                        if (response.dte_credit_note) {
                            new SlSaleCreditNote({
                                ...response.dte_credit_note,
                            }).downloadPdf()
                        }
                        this.reprintDTE(response.dte.dte)
                    }

                    // check is ticket
                    if (isSaleTicket) {
                    // if (
                    //     this.posSaleType === 1
                    //     // && dteProvider === 'integration'
                    // ) {
                        let roundingLaw = null
                        let change = null
                        if (
                            this.multipleSaleTicket &&
                            this.multipleSaleTicket.length === 1 &&
                            this.multipleSaleTicket[0].changed_dte &&
                            this.multipleSaleTicket[0].changed_dte.dte_number &&
                            response.url_file_dte
                        ) {
                            roundingLaw = cloneDeep(this.roundingLaw)
                            change = cloneDeep(this.change)
                            this.setArrayPayments([
                                ...this.arrayPayments,
                                {
                                    payment: response.dte_credit_note.total,
                                    paymentMethod: 8,
                                    paymentDetail: {
                                        sl_sale_credit_note_id:
                                            response.dte_credit_note.number,
                                    },
                                },
                            ])
                            this.printVoucher(response.url_file_dte)
                        }

                        const printParams = {
                            billNum: response.dte.dte.number,
                            eSignatureURL:
                                response.dte.dte.signature_url || null,
                            datetime: response.dte.dte.created_at || null,
                            currentEnv: dteProvider,
                        }

                        if (dteProvider !== 'open_factura')
                            printParams.options = { roundingLaw, change }

                        printRes = await this.printDTE(printParams)
                    }

                    // check is ticket & open_factura
                    if (isSaleTicket && isOpenFactura) {
                        if (dteCreditNote) {
                            await this.printCreditNote(dteCreditNote, dteProvider, dteResponse)
                        }
                    // }                    
                    // if (
                    //     this.posSaleType === 1 &&
                    //     dteProvider === 'open_factura'
                    // ) {
                        //
                        // console.log('RESPOSNSE HERE', response)
                        // SlSaleCreditNoteService.print()
                        // if (response.dte_credit_note) {
                        //     //
                        //     // const number  = response.dte_credit_note.number
                        //     // const company = this.companyData
                        //     // const branchOfficeId =

                        //     //
                        //     new SlSaleCreditNote().ticketHtmlPrintByNumber(
                        //         response.dte_credit_note.number,
                        //         this.companyData,
                        //         {
                        //             officeID: this.branchOfficeID,
                        //             officeName:
                        //                 this.branchOfficeName +
                        //                 ' - ' +
                        //                 this.branchOfficeAddress,
                        //             officeCashDeskId: this.cashDeskID,
                        //         }
                        //     )
                        // }
                        // printRes = await this.printDTE({
                        //     billNum: response.dte.dte.number,
                        //     eSignatureURL:
                        //         response.dte.dte.signature_url || null,
                        //     datetime: response.dte.dte.created_at || null,
                        //     currentEnv: dteProvider,
                        // })
                    }

                    // CHECK DTE CREDIT NOTE
                    // if (response.dte_credit_note) {
                    //     new SlSaleCreditNote(
                    //         ...response.dte_credit_note
                    //     ).downloadPdf()
                    // }
                } else {
                    this.lockScreen = false
                    this.resetSale()
                    this.resetCostumerState()
                    this.cleanForm()
                } //else{ printBoletaEmpleado()}

                // finish payment
                setTimeout(() => {
                    this.unlock()
                    this.resetSale()
                    this.resetCostumerState()
                    this.cleanForm()
                    this.$emit('paymentSuccess')
                }, 1000)

            } else if (response.status == 'error') {
                this.lockScreen = false
                this.initSnackbar({
                    typeMessage: 'warning',
                    message: {
                        title: 'Error',
                        body: response.error,
                    },
                    timeout: 0,
                    showProgress: false,
                    showCloseBtn: true,
                    closeBtnMessage: 'cerrar',
                })
            } else {
                this.lockScreen = false
                this.initSnackbar({
                    typeMessage: 'warning',
                    message: {
                        title: 'Error',
                        body: response.data.error || response.data.message,
                    },
                    timeout: 0,
                    showProgress: false,
                    showCloseBtn: true,
                    closeBtnMessage: 'cerrar',
                })
            }
        // },
        }, COMMIT_SALE_WAIT),
        cleanForm() {
            this.resetCashDeskState()
            this.$emit('clean-form')
        },
        annulSale() {
            this.setMessageConfirmSnack(ANNUL_SALE_ACTION)
            let payload = this.fillSnack(
                'warning',
                '¿Deseas anular la venta?',
                'Una vez anulada la venta no podras acceder a la información'
            )
            this.initSnackbar(payload)
        },
        cleanTicket() {
            this.resetSnackbarState()
            this.setMessageConfirmSnack(CLEAN_TICKET)
            let payload = this.fillSnack(
                'warning',
                '¿Deseas limpiar venta?',
                'Todos los datos ingresados seran borrados'
            )
            this.initSnackbar(payload)
        },
        blockAllKeyboardInput(e) {
            //allow panic button reload
            if (e.key === 'F10') return
            e.stopPropagation()
            e.preventDefault()
        },
        checkAuth() {
            this.authorize()
                .then((r) =>
                    r.status && [200, 201, 'success'].includes(r.status)
                        ? this.commitSale()
                        : this.showErrorSnack('Código Incorrecto')
                )
                .catch((e) =>
                    this.showErrorSnack(
                        e &&
                            e.response &&
                            e.response.data &&
                            e.response.data.error
                            ? e.response.data.error
                            : e || 'Ha ocurrido un error'
                    )
                )
        },
        showErrorSnack(text) {
            let payload = {
                typeMessage: 'error',
                message: {
                    title: 'Error',
                    body: text,
                },
                timeout: 6000,
                showProgress: false,
                showCloseBtn: true,
                closeBtnMessage: 'cerrar',
            }
            this.initSnackbar(payload)
        },

        /**
         * 
         */
        lock() {
            this.lockScreen = true
        },

        /**
         * 
         */
        printCreditNote(dteCreditNote, dteProvider, dteResponse) {
            return SlSaleCreditNoteService.printByNumber({
                number      : dteCreditNote.number,
                company     : this.companyData,
                office      : this.officeData,
                provider    : dteProvider,
                signature   : dteResponse.dte.signature_url,
            })
        },

        /**
         * 
         */
        showSuccessSaveSale() {
            this.initSnackbar({
                typeMessage : 'success',
                message     : {
                    title   : 'Exito',
                    body    : 'Venta registrada exitosamente.',
                },
                timeout     : 0,
                showProgress: false,
                showCloseBtn: true,
                closeBtnMessage: 'cerrar',
            })
        },

        /**
         * 
         */
        showWaitingSaveSale() {
            this.initSnackbar({
                typeMessage: 'info',
                message: {
                    title: 'Guardando Venta',
                    body: 'Guardando venta en la base de datos',
                },
                timeout: 0,
                showProgress: true,
                showCloseBtn: true,
                closeBtnMessage: '',
            })
        },

        /**
         * 
         */
        sale() {
            // return PosSaleService.pay().then(this.$success).catch(this.$error)
            // return this.submitSale()
        },

        /**
         * 
         */
        unlock() {
            this.lockScreen = false
        },
    },
    watch: {
        responseConfirm: async function (val) {
            if (val == CLEAN_TICKET) {
                this.resetSale()
                this.cleanForm()
                this.resetSnackbarState()
                this.resetCostumerState()
            }
        },
        lockScreen(v) {
            if (v) {
                window.focus()
                if (document.activeElement) {
                    document.activeElement.blur()
                }
                console.log('block-keyboard')
                window.addEventListener('keydown', this.blockAllKeyboardInput)
            } else {
                console.log('unlock keyboard')
                window.removeEventListener(
                    'keydown',
                    this.blockAllKeyboardInput
                )
            }
        },
        /*
        requireExtraCreditAuth: {
            immediate: true,
            handler(v) {
                if (v)
                    this.setPermission(
                        this.mixAuthCodePermissions
                            .CREATE_AUTH_POS_DAILY_SALE_REPORT
                    )
                else this.setPermission(null)
            },
        },
        */
    },
    components: { PaymentDetails, Pay, AuthModal },
    mixins: [CurrencyUtils],
    filters: {},
}
</script>

<style lang="scss" scoped>
.lock-screen {
    height: 100vh;
    width: 100vw;
    position: fixed;
    top: 0px;
    left: 0px;
    z-index: 12;
    background-color: rgba($color: #aaaaaa, $alpha: 0.5);
    cursor: wait;
}
</style>
